import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Unauthorized.css';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="unauthorized-icon">🚫</div>
        <h1>접근 권한이 없습니다</h1>
        <p>이 발전소에 접근할 권한이 없습니다.</p>
        <p>관리자에게 문의하세요.</p>
        <button 
          onClick={() => navigate('/')}
          className="back-button"
        >
          발전소 목록으로 돌아가기
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
